
import { Component, Vue } from "vue-property-decorator";
import { districtList } from "@/req/homeIndex";
import NavBar from "@/components/navBar.vue";
@Component({
  components: { NavBar },
})
export default class Logout extends Vue {
  public serverList = [];
  public gameId: any = "";
  public gameName: any = "";
  //   public obj: any = this.$route.query.obj;
  public created() {
    this.gameId = this.$route.query.id;
    this.gameName = this.$route.query.gameName;
    this.serverChange();
  }
  public async serverChange() {
    const res = await districtList({
      box_game_id: this.gameId,
    });
    if (res.code === 200) {
      this.serverList = res.data;
    }
  }
}
